import { STOREFRONTS } from '../data/storefronts.js';

export const APP_COUNTRY_QUERY_KEY = 'appCountry';

const ALLOWED_COUNTRIES = new Set(STOREFRONTS.map((sf) => sf.code));

function normalizeCountry(value) {
  const code = String(value ?? '').trim().toLowerCase();
  return ALLOWED_COUNTRIES.has(code) ? code : null;
}

export function buildAppComparisonHref(trackId, country = null) {
  const id = String(trackId ?? '').trim();
  const params = new URLSearchParams();
  params.set('appId', id);
  const normalizedCountry = normalizeCountry(country);
  if (normalizedCountry) {
    params.set(APP_COUNTRY_QUERY_KEY, normalizedCountry);
  }
  return `/?${params.toString()}`;
}

export function appCountryFromParams(input, fallback) {
  const params = input instanceof URLSearchParams
    ? input
    : new URLSearchParams(String(input ?? '').replace(/^\?/, ''));
  return normalizeCountry(params.get(APP_COUNTRY_QUERY_KEY)) ?? normalizeCountry(fallback) ?? 'us';
}
